export default {
    getShopLimit: {
        method: 'GET',
        url: '/admin/sysConfig/shopLimit/{shopId}',
        name: '获得场地限制配置',
    },
    shopLimit: {
        method: 'PUT',
        url: '/admin/sysConfig/shopLimit',
        name: '保存场地限制配置',
    },
}